export default (theme) => ({
  MuiButton: {
    root: {
      fontFamily: theme.typography.bold,
      '&.as-link': {
        ...theme.typography.body2,
        padding: 0,
        verticalAlign: "baseline",
        textTransform: "initial",
        color: "#055CA8",
        cursor: "pointer",
        textDecoration: "underline",
        textAlign: "left",
        '&:hover': {
          color: '#012646',
          background: 'transparent'
        }
      }
    },
    outlinedPrimary: {
      background: 'white'
    }
  },
  MuiButtonGroup: {
    groupedHorizontal: {
      borderRadius: '4px !important',
      '&:not(:last-child)':{
        borderRightColor: 'initial !important',
        marginRight: theme.spacing(2),
      },
    }
  }
});
//.MuiButtonGroup-groupedHorizontal-2610:not(:last-child)
